import React from 'react';

import {PageHeader} from 'presentation/components';
import {HeaderProps} from './types';

export function Header({headerTitle, headerSubtitle, onClickBackButton}: HeaderProps) {
	return (
		<PageHeader.Root title={headerTitle} onClickBackButton={onClickBackButton}>
			<PageHeader.Subtitle>{headerSubtitle}</PageHeader.Subtitle>
		</PageHeader.Root>
	);
}
